const data = [
  { id: 1, name: "Não conhecido" },
  { id: 2, name: "Conhecido e desprovido" },
  { id: 3, name: "Conhecido e provido" },
  { id: 4, name: "Conhecido e provido em parte" },
];

export default [...data];
